/**
 * Modal that appear when pressing Matching or when it is detected a Ad-hoc container with the same name as a fetched manifest containers.
 * @type {*|{}}
 */

var VRC = VRC || {};

VRC.FindMatchingContainerModal = (function(){
  var _template = 'find_matching_containers_modal';

  var createCtx = function(){
    return VRC.ContainerService.findMatchingContainers();
  };

  var attachEvents = function(ctx){
    var $modal = $('#modal');
    var $checkboxes =  $modal.find(':checkbox');
    $checkboxes.checkboxpicker();

    $modal.find('.btn-cancel').click(VRC.ModalManager.hide);

    var selectedContainers = [];
    $modal.find('.btn-confirm').click(function(){
      var checked = [];
      $modal.find('input:checked').each(function ()
      {
        selectedContainers.push(ctx[parseInt($(this).val())]);

      });


      VRC.ContainerService.switchContainers(selectedContainers);
      VRC.ModalManager.hide();
    });



  };

  var show = function(){
    var ctx = createCtx();
    if(!_.isEmpty(ctx)){
      VRC.ModalManager.show(_template, ctx);
    }

    attachEvents(ctx);

  };

  return {
    show : show,
    hide :  function(){VRC.ModalManager.hide()}
  }
})();